var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableViewOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.686275,
    y: 0.686275,
    width: 33.6274,
    height: 33.6274,
    rx: 2.7451,
    stroke: "#50605E",
    strokeWidth: 1.37255
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 4,
    height: 24,
    rx: 1.37255,
    transform: "rotate(-90 6 12)",
    fill: "#50605E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 20,
    width: 4,
    height: 24,
    rx: 1.37255,
    transform: "rotate(-90 6 20)",
    fill: "#50605E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 28,
    width: 4,
    height: 24,
    rx: 1.37255,
    transform: "rotate(-90 6 28)",
    fill: "#50605E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableViewOutline);
export default __webpack_public_path__ + "static/media/TableView_Outline.ffa1dce1ede6a017d02f58a9062dfafb.svg";
export { ForwardRef as ReactComponent };